export function isStringNullOrEmpty(it: string): boolean {
	return !(typeof it === "string" && it.length > 0);
}
